/**
 * Mobile Menu Email Signup
 * Handles duplicate email detection via localStorage
 * Submits form via AJAX to prevent page reload
 * Prevents drawer from closing on form interaction
 */

(function () {
    function init() {
        const form = document.querySelector('.mobile-menu-email-signup form');
        const duplicateError = document.querySelector('.mobile-menu-email-signup .duplicate-email-error');
        const successMessage = document.querySelector('.mobile-menu-email-signup .success-message');
        const emailInput = document.querySelector('.mobile-menu-email-signup input[type="email"]');
        const emailSignupContainer = document.querySelector('.mobile-menu-email-signup');
        const mobileMenuDrawer = document.querySelector('#mobile-menu');
        const fieldset = form ? form.querySelector('fieldset') : null;

        // Exit early if required elements are missing
        if (!form || !emailInput || !emailSignupContainer || !fieldset) {
            return;
        }

        // State tracking to prevent race conditions
        let isSubmitting = false;
        let fadeTimeout = null;
        let hideTimeout = null;

        // Helper to clear pending timeouts
        function clearPendingTimeouts() {
            if (fadeTimeout) clearTimeout(fadeTimeout);
            if (hideTimeout) clearTimeout(hideTimeout);
            fadeTimeout = null;
            hideTimeout = null;
        }

        // Helper to reset form to initial state
        function resetFormState() {
            clearPendingTimeouts();
            fieldset.style.display = '';
            if (duplicateError) {
                duplicateError.classList.add('hidden');
                duplicateError.classList.remove('fade-out');
            }
            if (successMessage) {
                successMessage.classList.add('hidden');
                successMessage.classList.remove('fade-out');
            }
            isSubmitting = false;
        }

        // Helper to show a message with auto-hide
        function showMessage(messageEl) {
            if (!messageEl) return;

            clearPendingTimeouts();
            fieldset.style.display = 'none';
            messageEl.classList.remove('hidden');
            messageEl.classList.remove('fade-out');

            fadeTimeout = setTimeout(function () {
                messageEl.classList.add('fade-out');
            }, 5000);

            hideTimeout = setTimeout(function () {
                resetFormState();
            }, 6000);
        }

        // Prevent form and inputs from triggering drawer close
        emailSignupContainer.addEventListener('click', function (e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }, true);

        form.addEventListener('submit', async function (e) {
            // Prevent default - we handle everything via AJAX
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            // Prevent double submission
            if (isSubmitting) return false;

            const email = emailInput.value.toLowerCase().trim();
            if (!email) return false;

            isSubmitting = true;

            const subscribedEmails = JSON.parse(localStorage.getItem('shardhouse_subscribed_emails') || '[]');

            // Check if email already subscribed (client-side only)
            if (subscribedEmails.includes(email)) {
                showMessage(duplicateError);
                isSubmitting = false;
                return false;
            }

            // Submit via AJAX to prevent page reload
            try {
                const formData = new FormData(form);
                await fetch(form.action, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'Accept': 'application/json'
                    }
                });
            } catch (err) {
                // Network errors are okay - we still save to localStorage
            }

            // Always store email and show success (optimistic UX)
            if (!subscribedEmails.includes(email)) {
                subscribedEmails.push(email);
                localStorage.setItem('shardhouse_subscribed_emails', JSON.stringify(subscribedEmails));
            }

            emailInput.value = '';
            showMessage(successMessage);
            isSubmitting = false;

            return false;
        }, true);

        // Reset form if drawer is closed
        const mobileMenuButton = document.querySelector('[aria-controls="HeaderDrawer"]') || document.querySelector('.mobile-menu-toggle');
        if (mobileMenuButton) {
            mobileMenuButton.addEventListener('click', function () {
                if (mobileMenuDrawer && !mobileMenuDrawer.classList.contains('menu-opening')) {
                    resetFormState();
                }
            });
        }
    }

    // Run on DOMContentLoaded or immediately if already loaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
